/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Lot_Trace_Step_GrowerInputs */

const vi_order_lot_trace_step_grower = /** @type {(inputs: Order_Lot_Trace_Step_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ dân`)
};

/**

* @param {Order_Lot_Trace_Step_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_step_grower = /** @type {((inputs?: Order_Lot_Trace_Step_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_Step_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_step_grower(inputs)
});